import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// Closes the shared inline-edit modal after a successful save.
// Rendered by the update.turbo_stream response into the modal body.
export default class extends Controller {
  connect() {
    const modalEl = document.getElementById("inline-edit-modal");
    if (!modalEl) return;
    const instance = Modal.getOrCreateInstance(modalEl);
    instance.hide();
  }
}
